import moment from 'moment';
import React from 'react';

import { safeFormatDateString } from '../../utils/dateUtils';

const DateCell = ({ row, column: { accessor } }) => {
  const rowValue = row[accessor];
  const date = rowValue && moment(rowValue).isValid() ? safeFormatDateString(rowValue) : rowValue;

  return <>{date}</>;
};

export default DateCell;
